const mappingCountries = {
    "Algeria": { "code": "ALG", "name": "Argelia" },
    "Belgium": { "code": "BEL", "name": "Bélgica" },
    "Brazil": { "code": "BRA", "name": "Brasil" },
    "Côte d'Ivoire": { "code": "CIV", "name": "Costa de Marfil" },
    "Croatia": { "code": "CRO", "name": "Croacia" },
    "Curaçao": { "code": "CUW", "name": "Curazao" },
    "Egypt": { "code": "EGY", "name": "Egipto" },
    "England": { "code": "ENG", "name": "Inglaterra" },
    "France": { "code": "FRA", "name": "Francia" },
    "Germany": { "code": "GER", "name": "Alemania" },
    "Haiti": { "code": "HAI", "name": "Haití" },
    "IR Iran": { "code": "IRN", "name": "Irán" },
    "Japan": { "code": "JPN", "name": "Japón" },
    "JORDAN": { "code": "JOR", "name": "Jordania" },
    "Korea Republic": { "code": "KOR", "name": "Corea del Sur" },
    "Morocco": { "code": "MAR", "name": "Marruecos" },
    "Netherlands": { "code": "NED", "name": "Países Bajos" },
    "New Zealand": { "code": "NZL", "name": "Nueva Zelanda" },
    "Norway": { "code": "NOR", "name": "Noruega" },
    "Saudi Arabia": { "code": "KSA", "name": "Arabia Saudita" },
    "Scotland": { "code": "SCO", "name": "Escocia" },
    "South Africa": { "code": "RSA", "name": "Sudáfrica" },
    "Spain": { "code": "ESP", "name": "España" },
    "Switzerland": { "code": "SUI", "name": "Suiza" },
    "Tunisia": { "code": "TUN", "name": "Túnez" },
    "United States": { "code": "USA", "name": "Estados Unidos" },
};

const toTitleCaseWord = (word) => {
    if (!word) return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const formatTeamDisplayName = (name) => {
    if (!name || typeof name !== "string") return "";
    const trimmed = name.trim();
    const letters = trimmed.replace(/[^a-zA-ZÁÉÍÓÚÜÑáéíóúüñ]/g, "");

    if (letters.length > 1 && letters === letters.toUpperCase()) {
        return trimmed
            .split(/(\s|-)/)
            .map((part) => (part === " " || part === "-" ? part : toTitleCaseWord(part)))
            .join("");
    }

    return trimmed;
};

export const getDisplayTeamName = (name, resolveTeamName) => {
    if (!name) return "";

    const resolved = resolveTeamName(name, false);
    if (resolved && resolved !== name) {
        return formatTeamDisplayName(resolved);
    }

    const customTeam = getCustomTeam(name);
    if (customTeam?.name) {
        return customTeam.name;
    }

    return formatTeamDisplayName(name);
};

export const getCustomTeam = (key) => {
    switch (key) {
        // mapping countries
        case "Algeria":
            return mappingCountries?.["Algeria"] ?? null;
        case "Belgium":
            return mappingCountries?.["Belgium"] ?? null;
        case "Brazil":
            return mappingCountries?.["Brazil"] ?? null;
        case "Côte d'Ivoire":
            return mappingCountries?.["Côte d'Ivoire"] ?? null;
        case "Croatia":
            return mappingCountries?.["Croatia"] ?? null;
        case "Curaçao":
            return mappingCountries?.["Curaçao"] ?? null;
        case "Egypt":
            return mappingCountries?.["Egypt"] ?? null;
        case "England":
            return mappingCountries?.["England"] ?? null;
        case "France":
            return mappingCountries?.["France"] ?? null;
        case "Germany":
            return mappingCountries?.["Germany"] ?? null;
        case "Haiti":
            return mappingCountries?.["Haiti"] ?? null;
        case "IR Iran":
            return mappingCountries?.["IR Iran"] ?? null;
        case "Japan":
            return mappingCountries?.["Japan"] ?? null;
        case "JORDAN":
            return mappingCountries?.["JORDAN"] ?? null;
        case "Korea Republic":
            return mappingCountries?.["Korea Republic"] ?? null;
        case "Morocco":
            return mappingCountries?.["Morocco"] ?? null;
        case "Netherlands":
            return mappingCountries?.["Netherlands"] ?? null;
        case "New Zealand":
            return mappingCountries?.["New Zealand"] ?? null;
        case "Norway":
            return mappingCountries?.["Norway"] ?? null;
        case "Saudi Arabia":
            return mappingCountries?.["Saudi Arabia"] ?? null;
        case "Scotland":
            return mappingCountries?.["Scotland"] ?? null;
        case "South Africa":
            return mappingCountries?.["South Africa"] ?? null;
        case "Spain":
            return mappingCountries?.["Spain"] ?? null;
        case "Switzerland":
            return mappingCountries?.["Switzerland"] ?? null;
        case "Tunisia":
            return mappingCountries?.["Tunisia"] ?? null;
        case "United States":
            return mappingCountries?.["United States"] ?? null;
        default:
            // response null if not found
            return null;
    }
}
